import {Component, Input, OnInit} from "@angular/core";
import {PedidosService} from "../../services/pedidos.service";
import {GrupolojasService} from "../../superadmin/services/grupolojas.service";

@Component({
  selector: 'app-sincronizar-99food-status',
  templateUrl: './sincronizar-food99.component.html',
  styleUrls: ['./sincronizar-food99.component.scss']
})
export class SincronizarFood99Component implements OnInit {
  @Input() pedido: any = {}
  @Input() modoGrupoLojas = false;

  constructor(private pedidosService: PedidosService, private grupolojasService: GrupolojasService) {

  }

  ngOnInit(): void {
  }

  async sincronizarStatusPedido($event: any) {

    this.pedido.sincronizando = true;

    const service: any = this.modoGrupoLojas ? this.grupolojasService : this.pedidosService;

    service.sincronizePedido99Food( this.pedido).then((resposta: any) => {
      this.pedido.sincronizando = false;
      if(resposta && resposta.id)
        Object.assign( this.pedido, resposta);
    }).catch((err) => {
      this.pedido.sincronizando = false;
    });

    $event.stopPropagation();
    $event.preventDefault();

    return false;
  }

}
